import { useEffect, useState } from "react";
import { IRAMStation, IRAMSystem } from "../../../app/models/ram";
import { RAMTableSession, RAMTableStationData, RAMTableSystemData } from "./RAMTable.interface";

function createRamSystemData(
    no: string,
    tagNumber: string,
    equipmentType: string,
    mttf: number,
    failureRate: number,
    mttr: number,
    operationTime: number,
    probabilityOfSuccess: number, 
    availability: number,
    unavailability: number, 
    m: number,
    remainingOfLife: number,
): RAMTableSystemData {
    return { 
        no, 
        tagNumber, 
        equipmentType, 
        mttf, 
        failureRate, 
        mttr, 
        operationTime, 
        probabilityOfSuccess, 
        availability,
        unavailability, 
        m,
        remainingOfLife,
    };
}

function createRamStationData(
    no: string,
    systemName: string,
    mttf: number,
    failureRate: number,
    mttr: number,
    operationTime: number,
    probabilityOfSuccess: number, 
    availability: number,
    unavailability: number, 
    m: number,
    remainingOfLife: number,
): RAMTableStationData {
    return { 
        no, 
        systemName, 
        mttf, 
        failureRate, 
        mttr, 
        operationTime,
        probabilityOfSuccess, 
        availability,
        unavailability, 
        m,
        remainingOfLife,
    };
}

export function useRAMTable(session: RAMTableSession | null, data: IRAMStation[] | IRAMSystem[]) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    
    const [rows, setRows] = useState<RAMTableStationData[] | RAMTableSystemData[]>([])
    
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(() => {
        if (data) {
            if (session === 'system') {
                (data as unknown as IRAMSystem[]).forEach((item) => {
                    setRows(prev => [
                        ...prev, 
                        createRamSystemData(
                            item.name,
                            item.tagNumber, 
                            item.equipmentType, 
                            item.mttf, 
                            item.failureRate, 
                            item.mttr, 
                            item.operationTime,
                            item.probabilitySuccess,
                            item.availability,
                            item.unavailability,
                            item.maintainability,
                            item.remainingOfLife
                        ) as any])
                })
            } else {
                (data as unknown as IRAMStation[]).forEach((item) => {
                    setRows(prev => [
                        ...prev, 
                        createRamStationData(
                            item.name, 
                            item.systemName, 
                            item.mttf, 
                            item.failureRate, 
                            item.mttr, 
                            item.operationTime,
                            item.probabilitySuccess,
                            item.availability,
                            item.unavailability,
                            item.maintainability,
                            item.remainingOfLife
                        ) as any])
                })
            }
        }

        return () => setRows([])
    }, [data, setRows, session])
    
    return { 
        handleChangePage, 
        handleChangeRowsPerPage,
        rows,
        page, 
        rowsPerPage,
    }
}
